/**
 * YCC Theme — assets/js/src/search-overlay.js
 *
 * Handles the header search icon toggle and search overlay open/close.
 *
 * Behaviour:
 *  - Clicking the search icon removes the `hidden` attribute and adds `.is-open`
 *    to the overlay, making it visible via CSS transition.
 *  - Clicking the close button or pressing Escape closes the overlay.
 *  - Focus is trapped inside the overlay while it is open (moves to the
 *    search input on open, returns to the toggle button on close).
 *
 * @package YCC
 */

(function () {
  "use strict";

  const searchToggle = document.querySelector(".site-header__search-toggle");
  const searchwrapper = document.getElementById("headersearch_wrapper");
  const siteNav = document.getElementById("site-navigation");
  const headerActions = document.getElementById("site-header__actions");

  const form_wrapper = document.querySelector(".footer_search .form_wrapper");
  const footer_label = document.querySelector(".footer_search .form_label");

  //if (!searchToggle || !searchwrapper) return;

  const closeBtn = searchwrapper.querySelector(".stk--svg-wrapper svg");
  const searchInput = searchwrapper.querySelector(".site-search__input");
  const footerSearchInput = form_wrapper.querySelector(
    ".footer-search-form__input",
  );

  function openFooterSearch() {
    console.log("opening footer search");
    form_wrapper.classList.remove("hidden");
    footer_label.classList.add("hidden");
    footerSearchInput.focus();
  }

  function closeFooterSearch() {
    console.log("closing footer search");
    form_wrapper.classList.add("hidden");
    footer_label.classList.remove("hidden");
  }

  function openSearch() {
    console.log("opening search");

    searchwrapper.classList.remove("hidden");

    siteNav.classList.add("hidden");
    headerActions.classList.add("hidden");
    // Trigger CSS transition on next frame
    // requestAnimationFrame(function () {
    //   searchwrapper.classList.add("is-open");
    // });
    searchToggle.setAttribute("aria-expanded", "true");
    // Move focus to the search input
    if (searchInput) {
      searchInput.focus();
    }
  }

  // -------------------------------------------------------------------------
  // Close overlay
  // -------------------------------------------------------------------------

  function closeSearch() {
    console.log("closing search");
    siteNav.classList.remove("hidden");
    headerActions.classList.remove("hidden");
    searchwrapper.classList.add("hidden");
    searchToggle.setAttribute("aria-expanded", "false");
  }

  // -------------------------------------------------------------------------
  // Event listeners
  // -------------------------------------------------------------------------

  searchToggle.addEventListener("click", openSearch);
  footer_label.addEventListener("mouseenter", openFooterSearch);
  form_wrapper.addEventListener("mouseout", closeFooterSearch);

  if (closeBtn) {
    closeBtn.addEventListener("click", closeSearch);
  }

  // Close on Escape key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && overlay.classList.contains("is-open")) {
      closeSearch();
    }
  });
})();
